import { createClient } from 'laboratory-lib';
import { getPortalExperimentsConfig } from './getExperimentsConfig';
import { getPortalId } from '../store/auth/selectors';
export const getPortalIdTreatmentsClient = state => {
  return createClient({
    timeout: 3000,
    experiments: getPortalExperimentsConfig(),
    identifiers: {
      portalId: getPortalId(state),
      utk: null
    }
  });
};